import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const notificationRoutes: Route = {
    path: '',
    data: { title: 'notification' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'notifications' },
        {
            path: 'notification-channel',
            loadComponent: () =>
                import('./notification-channel/notification-channel.component').then((m) => m.NotificationChannelComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Notification channel' },
        },
        {
            path: 'notification-channel-user-deny',
            loadComponent: () =>
                import('./notification-channel-user-deny/notification-channel-user-deny.component').then(
                    (m) => m.NotificationChannelUserDenyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Notification channel user deny' },
        },
        {
            path: 'notification-group',
            loadComponent: () =>
                import('./notification-group/notification-group.component').then((m) => m.NotificationGroupComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Notification group' },
        },
        {
            path: 'notification-recipient-type',
            loadComponent: () =>
                import('./notification-recipient-type/notification-recipient-type.component').then(
                    (m) => m.NotificationRecipientTypeComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Notification recipient type' },
        },
        {
            path: 'notification-severity',
            loadComponent: () =>
                import('./notification-severity/notification-severity.component').then((m) => m.NotificationSeverityComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Notification severity' },
        },
        {
            path: 'notifications',
            loadComponent: () =>
                import('./notifications/notifications.component').then((m) => m.NotificationsComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Notifications' },
        },
        {
            path: 'notification-test',
            loadComponent: () =>
                import('./notification-test/notification-test.component').then((m) => m.NotificationTestComponent),
            // canActivate: pagePermissionActivate,
            data: { title: 'Notification test' },
        },
        {
            path: 'notification-template',
            loadComponent: () =>
                import('./notification-template/notification-template.component').then((m) => m.NotificationTemplateComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Notification template' },
        },
    ],
};
